import { createContext } from "react";
import { ArticleCardProps } from "./ArticleCard";
import CoverImageCard from "./CoverImageCard";
import { FlexColumn } from "../Styles";
import ArticleContent from "./articleContent";

export const ArticleCardContext = createContext({} as ArticleCardProps.Context);
const ArticleCard = ({ article }: ArticleCardProps.IProps) => {
  const ArticleCardContextValue = { ...article };
  return (
    <ArticleCardContext.Provider value={ArticleCardContextValue}>
      <FlexColumn $gapInPx={32}>
        <CoverImageCard />
        <ArticleContent />
      </FlexColumn>
    </ArticleCardContext.Provider>
  );
};

export default ArticleCard;
